import type {RowData} from 'features/eag-grid';

/**
 * Returns the grid rows whose backend-provided actions include the given action key
 * (e.g. 'issue', 'request', 'requestCancellation'). The backend decides per-row action
 * availability from the item's material state, so this is the same applicability signal
 * the grid uses for its own row/bulk action buttons.
 */
export const getDirectSaleItemRowsWithAction = (rows: RowData[], actionKey: string): RowData[] =>
  rows.filter(
    (row) => row.actions.primary.includes(actionKey) || row.actions.secondary.includes(actionKey)
  );
